import { useMemo, useState } from "react";
import { X } from "lucide-react";
import type { AdminUserRequestedFor } from "../../api/adminUsers";
import { ModalPortal } from "../ModalPortal/ModalPortal";
import { RequestTablePagination } from "../RequestTable/RequestTablePagination";
import "./AdminUserSitesModal.scss";

const PAGE_SIZE = 15;

interface AdminUserSitesModalProps {
  sites: AdminUserRequestedFor[];
  userLabel: string;
  onClose: () => void;
}

export const AdminUserSitesModal = ({ sites, userLabel, onClose }: AdminUserSitesModalProps) => {
  const [page, setPage] = useState(0);
  const totalPages = Math.max(1, Math.ceil(sites.length / PAGE_SIZE));
  const canGoNext = page + 1 < totalPages;

  const pageItems = useMemo(
    () => sites.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE),
    [page, sites]
  );

  return (
    <ModalPortal>
      <div className="detail-checks-modal-overlay" onClick={onClose}>
        <div
          className="detail-checks-modal admin-user-sites-modal"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="detail-checks-modal-head">
            <h3>Сайты — {userLabel}</h3>
            <button type="button" className="detail-tasklist-close" onClick={onClose} aria-label="Закрыть">
              <X size={18} />
            </button>
          </div>

          <div className="detail-checks-modal-body admin-user-sites-modal-body">
            <p className="admin-user-sites-modal-total">Всего: {sites.length}</p>
            <div className="admin-user-sites-modal-list">
              {pageItems.map((site, index) => (
                <div
                  key={`${site.inn ?? "inn"}-${site.siteUrl ?? page * PAGE_SIZE + index}`}
                  className="admin-user-sites-modal-item"
                >
                  <span className="admin-user-sites-modal-inn">{site.inn?.trim() || "—"}</span>
                  <span className="admin-user-sites-modal-url">{site.siteUrl?.trim() || "—"}</span>
                </div>
              ))}
            </div>
          </div>

          {totalPages > 1 ? (
            <div className="detail-checks-modal-footer admin-user-sites-modal-pagination">
              <RequestTablePagination
                page={page}
                totalPages={totalPages}
                pageSize={PAGE_SIZE}
                canGoNext={canGoNext}
                onPageChange={setPage}
                showPageSizeSelect={false}
              />
            </div>
          ) : null}
        </div>
      </div>
    </ModalPortal>
  );
};
